/** @format */
import { useContext, useState } from 'react';

import { BasketItem } from '@toucan/types/mpbx/basket';
import { ProductConditionValue } from '@toucan/types/product';

import { BasketContext } from '@toucan/client/features/basket/context/basket';
import { ProductSummaryV2 } from '@toucan/client/global/product';

/*
 * This is a like-for-like replica of the add to basket handler from the legacy product page
 * Some of the logic could do with a clean-up once the legacy product page is removed
 */
export const useAddToBasketHandler = (product: ProductSummaryV2) => {
    const { basket } = useContext(BasketContext);
    const { addToBasket, isInitialised } = useContext(BasketContext);

    const [isLoading, setIsLoading] = useState(false);
    const [isErrorAddingToBasket, setIsErrorAddingToBasket] =
        useState<boolean>(false);

    const isInBasket = basket?.items.some(
        (item: BasketItem) =>
            item.sku === product?.sku || item.product.id === product?.id
    );

    const isNewProduct = product.condition === ProductConditionValue.NEW;

    const handleAddToBasket = async () => {
        try {
            setIsLoading(true);
            setIsErrorAddingToBasket(false);

            if (
                (isInBasket && !isNewProduct) ||
                (!product.id && !isNewProduct) ||
                !product.modelId
            ) {
                return;
            }

            const image = product?.images?.[0]?.imageUrl;
            await addToBasket({ ...product, image }, 1);
        } catch (e) {
            setIsErrorAddingToBasket(true);
        } finally {
            setIsLoading(false);
        }
    };

    return {
        handleAddToBasket,
        isErrorAddingToBasket,
        isLoading: isLoading || !isInitialised,
        isInBasket,
    };
};
